import React from "react";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import createSvgIcon from "@mui/icons-material/utils/createSvgIcon";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { useTranslation } from "react-i18next";

const ContentPasteIcon = createSvgIcon(
  <path d="M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z" />,
  "ContentPaste"
);

function QuickTools({ handlePopover, isEditable }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: "flex" }}>
      <Tooltip title={t("common.buttons.copy")}>
        <IconButton
          aria-label="copy"
          onClick={() => handlePopover({ type: "copy" })}
          size="large">
          <FileCopyOutlinedIcon />
        </IconButton>
      </Tooltip>
      {isEditable ? (
        <React.Fragment>
          <Tooltip title={t("common.buttons.paste")}>
            <IconButton
              aria-label="paste"
              onClick={() => handlePopover({ type: "paste" })}
              size="large">
              <ContentPasteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("common.buttons.remove")}>
            <IconButton
              aria-label="delete"
              onClick={() => handlePopover({ type: "delete" })}
              size="large">
              <DeleteOutlinedIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title={t("create.newSurvey")}>
            <IconButton
              aria-label="add"
              style={{ marginRigh: 8 }}
              onClick={() => handlePopover({ type: "add" })}
              size="large">
              <AddCircleOutlineOutlinedIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      ) : null}
    </div>
  );
}

export default QuickTools;
